import { Box, Hide } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';
import { useUserStore } from 'store/user';

import type { Props } from './types';

import AppErrorBoundary from 'ui/shared/AppError/AppErrorBoundary';
import ContentLoader from 'ui/shared/ContentLoader';
import HeaderAlert from 'ui/snippets/header/HeaderAlert';
import HeaderDesktop from 'ui/snippets/header/HeaderDesktop';
import HeaderMobile from 'ui/snippets/header/HeaderMobile';

import * as Layout from './components';

const LayoutDefault = ({ children }: Props) => {
  const router = useRouter();
  const { isAuthenticated } = useUserStore();

  if (router.pathname?.includes('login')) {
    return (
      <Layout.Content>
        <Box
          display="flex"
          width="100%"
          justifyContent="center"
          height="100vh"
          alignItems="center"
        >
          { children }
        </Box>
      </Layout.Content>
    );
  }

  if (!isAuthenticated && !router.pathname?.includes('login')) {
    return (
      <Box
        display="flex"
        width="100%"
        justifyContent="center"
        height="100vh"
        alignItems="center"
      >
        <ContentLoader/>
      </Box>
    );
  }

  return (
    <Layout.Container>
      <Hide above="lg" >
        <Layout.TopRow/>
      </Hide>
      <Layout.NavBar/>
      <HeaderMobile/>
      <Layout.MainArea>
        <Layout.SideBar/>
        <Layout.MainColumn>
          <HeaderAlert/>
          <HeaderDesktop/>
          <AppErrorBoundary>
            <Layout.Content>{ children }</Layout.Content>
          </AppErrorBoundary>
        </Layout.MainColumn>
      </Layout.MainArea>
      { /* <Layout.Footer /> */ }
    </Layout.Container>
  );
};

export default LayoutDefault;
